if (!customElements.get('cart-checkout-validation')) {
  customElements.define(
    'cart-checkout-validation',
    class CartCheckoutValidation extends HTMLElement {
      constructor() {
        super();
        this.submitButton = this.querySelector('[name="checkout"]');
        if (!this.submitButton) return;

        this.requiresClinic = this.submitButton.dataset.requiresClinic === 'true';
        this.noClinics = this.submitButton.dataset.noClinics === 'true';
        this.clinicHelper = this.querySelector('.cart-checkout__clinic-helper');
        this.noClinicHelper = this.querySelector('.cart-checkout__no-clinic-helper');

        this.clinicSelectedHandler = () => this.checkClinicSelection();
      }

      connectedCallback() {
        if (!this.submitButton) return;

        if (this.noClinics) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('disabled');
          if (this.noClinicHelper) this.noClinicHelper.classList.remove('hidden');
        } else if (this.requiresClinic) {
          this.checkClinicSelection();
          document.addEventListener('clinic:selected', this.clinicSelectedHandler);
        }
      }

      disconnectedCallback() {
        if (this.clinicSelectedHandler) {
          document.removeEventListener('clinic:selected', this.clinicSelectedHandler);
        }
      }

      checkClinicSelection() {
        if (!this.submitButton) return;
        const selectedClinic = sessionStorage.getItem('selected_clinic');
        const isSelected = !!selectedClinic;

        const isCartEmpty = this.submitButton.dataset.cartEmpty === 'true';

        if (isSelected) {
          if (!isCartEmpty) {
            this.submitButton.removeAttribute('disabled');
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('disabled');
          }
          if (this.clinicHelper) this.clinicHelper.classList.add('hidden');
        } else {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('disabled');
          if (this.clinicHelper) this.clinicHelper.classList.remove('hidden');
        }
      }
    }
  );
}
